import { CommonModule } from '@angular/common';
import { Component, inject, effect, ViewChild, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbDatepickerModule, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetGenerateService } from '@services/budget-generate.service';
import Swal from 'sweetalert2';
import { registerLocaleData } from '@angular/common';
import { Entity } from '@model/entity.model';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { EmployeeModel } from './employee.model';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

registerLocaleData(localeEs);


@Component({
  selector: 'app-employee',
  standalone: true,
  imports: [ CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbModule
  ],
  providers: [NgbModal,{ provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.css',
})
export class EmployeeComponent {
  @ViewChild('modal_diverse', { static: true }) modalDiverse: any;
  @ViewChild('ngSelectAssinet', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild('ngSelect', { static: false }) ngSelect: NgSelectComponent;
  @ViewChild('nameInput') nameInput: ElementRef;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  private _budgeGenrateService = inject(BudgetGenerateService);
  public filter: EmployeeModel = new EmployeeModel();
  public entitySelected: Entity;
  public dataEmployeeType;
  public dataListDiverse;
  public dataNgSelectAssinet;
  public dataDiverse;  
  public dataDiverseTemp;
  // Dual-panel state & collections
  public activeEmployees: any[] = [];
  public filteredActiveEmployees: any[] = [];
  public inactiveEmployees: any[] = [];
  public filteredInactiveEmployees: any[] = [];
  public pendingApsEmployees: any[] = [];
  public filteredPendingApsEmployees: any[] = [];

  // Tab & Filters
  public showRightPanel: boolean = false;
  public rightTab: 'aps' | 'aasinet' | 'inactive' = 'aps';
  public aasinetEmployees: any[] = [];
  public filteredAasinetEmployees: any[] = [];
  public txtFindAasinet: string = '';
  public selectedAasinetCount: number = 0;
  public isAllAasinetSelected: boolean = false;
  public isSyncingAasinet: boolean = false;
  public txtFindActive: string = '';
  public selectedActiveTypeFilter: any = null;
  public txtFindAps: string = '';
  public selectedApsTypeFilter: any = null;
  public txtFindInactive: string = '';
  public apsStatusFilter: 'all' | 'new' | 'update' = 'all';
  public newApsCount: number = 0;
  public updateApsCount: number = 0;
  public selectedNewCount: number = 0;
  public selectedUpdateCount: number = 0;

  // Checkbox batch states
  public isAllApsSelected: boolean = true;
  public selectedApsCount: number = 0;
  public isAllInactiveSelected: boolean = false;
  public selectedInactiveCount: number = 0;
  public isLoadingAps: boolean = false;
  public txtFind;
  public tabArea = 'diverse';
  public modalHeaderDiverse: string;
  public formDiverse: FormGroup;
  public id;
  public diverseFinded=false
  public diverseCopy;
  public isNewDiverse=false;
  closeResult: string;
  modalOptions = {
    animation: true,
  };
  budgetVersionSelected;
  budgetEmployeeType;
  budgetFund;
  fundSelect;
  selectedEmployee;
  selectedEmployeeType;
  budgetStatus;
  constructor(private modalService: NgbModal, private formBuilder: FormBuilder,) {

    effect(()=> {
      this.entitySelected = this.userService.sharingEntity();
      this.dataEmployeeType = this.userService.sharingEmployeeType()
      const budgetFund=this.userService.sharingBudgetFund()
      this.budgetVersionSelected=this.userService.sharingBudgetVersion()			
       if (this.budgetVersionSelected?.year) {
        this.dataListDiverse=undefined;  
        this.budgetFund=budgetFund;
        this.selectedEmployeeType=this.dataEmployeeType[0]?.employeeType;
        this.fundSelect = this.budgetFund[0]?.fundCode;   
        this.filter.year = this.budgetVersionSelected.year;
        this.filter.version = this.budgetVersionSelected.version; 
        this.budgetStatus = this.budgetVersionSelected.status;
        this.getDiverse();
      }
		})
  }


  /**crear formulario reactivo diverso*/
  createFormDiverse() {
    this.formDiverse = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(1)]],
      names: ['', Validators.required],
      type: ['', [Validators.required]],
      year: ['', [Validators.required]],
      version: ['', [Validators.required]],
      entityCode: ['', [Validators.required]],
      fundCode: ['', [Validators.required]],
      employeeFmr: [null, ],
    });
  }


  ngOnInit() {
    this.createFormDiverse();
  }


    refreshApsClick() {
    this.showRightPanel = true;
    this.rightTab = 'aps';
    this.loadPendingAps();
  }

  toggleRightPanel() {
    this.showRightPanel = !this.showRightPanel;
    if (this.showRightPanel) {
      if (this.rightTab === 'aps' && (!this.pendingApsEmployees || this.pendingApsEmployees.length === 0)) {
        this.loadPendingAps();
      } else if (this.rightTab === 'aasinet' && (!this.aasinetEmployees || this.aasinetEmployees.length === 0)) {
        this.getAssinetSubAccount();
      }
    }
  }

  syncSubAccounts() {
    this.isSyncingAasinet = true;
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timerProgressBar: true
    });
    Toast.fire({
      icon: 'info',
      title: 'Sincronizando diversos con Aasinet...',
      timer: 1500
    });

    this._budgeGenrateService.syncAssinetSubAccount().subscribe({
      next: (res) => {
        this.isSyncingAasinet = false;
        this.getAssinetSubAccount();
        Toast.fire({
          icon: 'success',
          title: 'Diversos sincronizados correctamente',
          timer: 2500
        });
      },
      error: (error) => {
        this.isSyncingAasinet = false;
        Toast.fire({
          icon: 'error',
          title: 'Error al sincronizar diversos con Aasinet.',
          timer: 3000
        });
      }
    });
  }

 


  /**combina los datos del formDiverso con los datos q faltan para hacer la peticion en el servicio */
  newData(data) {
    data['entityCode'] = this.entitySelected?.code;
    data['year']=this.filter.year;
    data['version']=this.filter.version
    return data;
  }

  /*mensaje de cargando */
  loading(title:string='Cargando...') {
    Swal.fire({
      title: title,
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }


  loadPendingAps(showToast: boolean = false) {
    let filter: EmployeeModel = new EmployeeModel();
    filter.fundCode = this.fundSelect;
    filter.year = this.filter.year;
    filter.version = this.filter.version;

    this.isLoadingAps = true;
    this._budgeGenrateService.previewImportEmployee(filter).subscribe({
      next: (res: any[]) => {
        this.isLoadingAps = false;
        this.pendingApsEmployees = (res || []).map(emp => ({
          ...emp,
          selected: true,
          selectedType: emp.type || this.selectedEmployeeType || 3,
          selectedFmr: (emp.type === 1 || emp.type === 2) ? emp.fmr : (emp.fmr || null)
        }));
        this.newApsCount = (this.pendingApsEmployees || []).filter(e => e.syncStatus === 'NEW').length;
        this.updateApsCount = (this.pendingApsEmployees || []).filter(e => e.syncStatus === 'UPDATE').length;
        this.filterPendingAps();
        this.updateApsSelectionSummary();
        if (showToast) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timerProgressBar: true
          });
          Toast.fire({
            icon: 'success',
            title: 'Datos de APS actualizados',
            timer: 2000
          });
        }
      },
      error: (err) => {
        this.isLoadingAps = false;
        console.error('Error al cargar candidatos de APS:', err);
      }
    });
  }

  filterActiveEmployees() {
    const term = (this.txtFindActive || '').toLowerCase().trim();
    const typeFilter = this.selectedActiveTypeFilter;
    this.filteredActiveEmployees = this.activeEmployees.filter(e => {
      const matchTerm = !term ||
        (e.names && e.names.toLowerCase().includes(term)) ||
        (e.code && e.code.toString().includes(term)) ||
        (e.departamentCode && e.departamentCode.toLowerCase().includes(term));
      const matchType = !typeFilter || e.type == typeFilter;
      return matchTerm && matchType;
    });
  }

  filterPendingAps() {
    const term = (this.txtFindAps || '').toLowerCase().trim();
    const typeFilter = this.selectedApsTypeFilter;
    const statusFilter = this.apsStatusFilter;

    this.filteredPendingApsEmployees = this.pendingApsEmployees.filter(e => {
      const matchTerm = !term ||
        (e.names && e.names.toLowerCase().includes(term)) ||
        (e.code && e.code.toString().includes(term)) ||
        (e.departamentCode && e.departamentCode.toLowerCase().includes(term)) ||
        (e.departamentName && e.departamentName.toLowerCase().includes(term)) ||
        (e.currentNames && e.currentNames.toLowerCase().includes(term));
      const matchType = !typeFilter || e.selectedType == typeFilter;
      const matchStatus = statusFilter === 'all' ||
        (statusFilter === 'new' && e.syncStatus === 'NEW') ||
        (statusFilter === 'update' && e.syncStatus === 'UPDATE');
      return matchTerm && matchType && matchStatus;
    });
    this.updateApsSelectionSummary();
  }

  filterInactiveEmployees() {
    const term = (this.txtFindInactive || '').toLowerCase().trim();
    this.filteredInactiveEmployees = this.inactiveEmployees.filter(e => {
      return !term ||
        (e.names && e.names.toLowerCase().includes(term)) ||
        (e.code && e.code.toString().includes(term)) ||
        (e.departamentCode && e.departamentCode.toLowerCase().includes(term));
    });
    this.updateInactiveSelectionSummary();
  }

  toggleSelectAllAps() {
    this.isAllApsSelected = !this.isAllApsSelected;
    this.filteredPendingApsEmployees.forEach(e => e.selected = this.isAllApsSelected);
    this.updateApsSelectionSummary();
  }

  updateApsSelectionSummary() {
    this.selectedApsCount = this.filteredPendingApsEmployees.filter(e => e.selected).length;
    this.isAllApsSelected = this.filteredPendingApsEmployees.length > 0 &&
      this.filteredPendingApsEmployees.every(e => e.selected);
  }

  toggleSelectAllInactive() {
    this.isAllInactiveSelected = !this.isAllInactiveSelected;
    this.filteredInactiveEmployees.forEach(e => e.selected = this.isAllInactiveSelected);
    this.updateInactiveSelectionSummary();
  }

  updateInactiveSelectionSummary() {
    this.selectedInactiveCount = this.filteredInactiveEmployees.filter(e => e.selected).length;
    this.isAllInactiveSelected = this.filteredInactiveEmployees.length > 0 &&
      this.filteredInactiveEmployees.every(e => e.selected);
  }

  onApsTypeChange(emp: any) {
    if (emp.selectedType != 1 && emp.selectedType != 2) {
      emp.selectedFmr = null;
    } else if (!emp.selectedFmr && emp.fmr) {
      emp.selectedFmr = emp.fmr;
    }
    this.updateApsSelectionSummary();
  }

  onApsFmrChange(emp: any) {
    this.updateApsSelectionSummary();
  }

  importSingleAps(emp: any) {
    const isNew = emp.syncStatus === 'NEW';
    this.loading(isNew ? `Incorporando a ${emp.names}...` : `Actualizando datos de ${emp.names}...`);
    let filter: EmployeeModel = new EmployeeModel();
    filter.fundCode = this.fundSelect;
    filter.year = this.filter.year;
    filter.version = this.filter.version;

    const fmrValue = (emp.selectedType == 1 || emp.selectedType == 2)
      ? (emp.selectedFmr !== null && emp.selectedFmr !== undefined && emp.selectedFmr !== '' ? Number(emp.selectedFmr) : null)
      : null;

    const selectedItems = [{
      code: emp.code,
      type: Number(emp.selectedType),
      fmr: fmrValue
    }];
    this._budgeGenrateService.importEmployee(filter, { selectedItems }).subscribe({
      next: () => {
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: isNew ? 'Empleado Incorporado' : 'Empleado Actualizado',
          text: isNew
            ? `${emp.names} ha sido incorporado al presupuesto activo.`
            : `Los datos de ${emp.names} han sido actualizados con APS exitosamente.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true
        });
        this.getDiverse();
      },
      error: (err) => {
        Swal.close();
        console.error('Error al procesar empleado:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.error?.message || 'No se pudo procesar el empleado.',
        });
      }
    });
  }

  importSelectedAps() {
    const selectedItems = this.filteredPendingApsEmployees
      .filter(e => e.selected)
      .map(e => {
        const fmrValue = (e.selectedType == 1 || e.selectedType == 2)
          ? (e.selectedFmr !== null && e.selectedFmr !== undefined && e.selectedFmr !== '' ? Number(e.selectedFmr) : null)
          : null;
        return {
          code: e.code,
          type: Number(e.selectedType),
          fmr: fmrValue
        };
      });

    if (selectedItems.length === 0) return;

    this.loading(`Importando ${selectedItems.length} empleado(s)...`);
    let filter: EmployeeModel = new EmployeeModel();
    filter.fundCode = this.fundSelect;
    filter.year = this.filter.year;
    filter.version = this.filter.version;

    this._budgeGenrateService.importEmployee(filter, { selectedItems }).subscribe({
      next: () => {
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'Importación Completada',
          text: `Se han incorporado exitosamente ${selectedItems.length} empleado(s).`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        });
        this.getDiverse();
      },
      error: (err) => {
        Swal.close();
        console.error('Error al importar:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.error?.message || 'Ocurrió un error al importar los empleados.',
        });
      }
    });
  }

  excludeEmployee(d: any) {
    this._budgeGenrateService.updateDepartamentEmployee({ id: d.id, isActive: false }).subscribe({
      next: () => {
        Swal.fire({
          icon: 'info',
          title: 'Empleado Excluido',
          text: `${d.names} ha sido movido a la bandeja de Inactivos.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true
        });
        this.getDiverse();
      },
      error: (err) => console.error(err)
    });
  }

  reactivateEmployee(d: any) {
    this._budgeGenrateService.updateDepartamentEmployee({ id: d.id, isActive: true }).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Empleado Reactivado',
          text: `${d.names} ha regresado al presupuesto activo.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true
        });
        this.getDiverse();
      },
      error: (err) => console.error(err)
    });
  }

  reactivateSelectedInactive() {
    const selected = this.filteredInactiveEmployees.filter(e => e.selected);
    if (selected.length === 0) return;

    this.loading(`Reactivando ${selected.length} empleado(s)...`);
    const calls = selected.map(e => this._budgeGenrateService.updateDepartamentEmployee({ id: e.id, isActive: true }));
    let completed = 0;
    calls.forEach(obs => {
      obs.subscribe({
        next: () => {
          completed++;
          if (completed === calls.length) {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Empleados Reactivados',
              text: `Se reactivaron ${selected.length} empleado(s).`,
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true
            });
            this.getDiverse();
          }
        },
        error: (err) => console.error(err)
      });
    });
  }

  syncEmployee(){
    this.loading('Importando de APS');
    let filter:EmployeeModel = new EmployeeModel();
    filter.fundCode=this.fundSelect;
    filter.year=this.filter.year;
    filter.version=this.filter.version;
    this._budgeGenrateService.importEmployee(filter).subscribe((res)=>{
      this.getDiverse();
      Swal.close();
    })
  }


  /*trae los datos diverse en el servicio de budget  */
  getDiverse() {
    this._budgeGenrateService.getDepartamentEmployee(this.filter).subscribe((diverso) => {
      const arrayEmployeeType=this.dataEmployeeType.map(d=>d.employeeType);
      const dataFiltred=diverso.filter(d=>arrayEmployeeType.includes(d.type));
      this.dataDiverse = dataFiltred  
      this.dataDiverseTemp=this.dataDiverse;    
        this.dataDiverseTemp=JSON.parse(JSON.stringify(this.dataDiverse));
        this.dataListDiverse=this.ngSelectData(diverso)
        this.changeFund(this.fundSelect);
        this.getAssinetSubAccount();
    }, (error => console.error(error)));
  }


  /*trae los datos subaccount en el servicio de budget  */
  getAssinetSubAccount() {
    this._budgeGenrateService.getAasinetSubAccount().subscribe((res) => { 
      res = (res || []).filter(d => d.type == 'FUNC' || (d.code == 2000 && d.type == 'D150'));
      this.dataNgSelectAssinet = this.mapSelectAassinet(res);
      const unassigned = res.filter(d => !this.findEmployee(d.code));
      this.aasinetEmployees = unassigned.map(d => ({
        code: d.code,
        name: d.name,
        selected: false,
        selectedType: this.selectedEmployeeType || 3,
        selectedFmr: null
      }));
      this.filterAasinetEmployees();
      this.updateAasinetSelectionSummary();
      this.changeFund(this.fundSelect);
    }, (error => console.error(error)));
  }

  filterAasinetEmployees() {
    const term = (this.txtFindAasinet || '').toLowerCase().trim();
    this.filteredAasinetEmployees = (this.aasinetEmployees || []).filter(e => {
      return !term ||
        String(e.code).toLowerCase().includes(term) ||
        (e.name || '').toLowerCase().includes(term);
    });
    this.updateAasinetSelectionSummary();
  }

  toggleSelectAllAasinet() {
    this.isAllAasinetSelected = !this.isAllAasinetSelected;
    this.filteredAasinetEmployees.forEach(e => e.selected = this.isAllAasinetSelected);
    this.updateAasinetSelectionSummary();
  }

  updateAasinetSelectionSummary() {
    this.selectedAasinetCount = this.filteredAasinetEmployees.filter(e => e.selected).length;
    this.isAllAasinetSelected = this.filteredAasinetEmployees.length > 0 &&
      this.filteredAasinetEmployees.every(e => e.selected);
  }

  onAasinetTypeChange(emp: any) {
    if (emp.selectedType != 1 && emp.selectedType != 2) {
      emp.selectedFmr = null;
    }
  }

  importSingleAasinet(emp: any) {
    this.loading('Incorporando a ' + emp.name + '...');
    const payload = {
      code: emp.code,
      names: emp.name,
      year: this.filter.year,
      version: this.filter.version,
      entityCode: this.entitySelected?.code,
      fundCode: this.fundSelect,
      type: Number(emp.selectedType || 3),
      employeeFmr: (emp.selectedType == 1 || emp.selectedType == 2) && emp.selectedFmr ? Number(emp.selectedFmr) : null,
      departamentCode: '-1',
      departamentFundCode: '0001',
      isActive: 1
    };

    this._budgeGenrateService.saveDepartamentEmployee(payload).subscribe({
      next: () => {
        Swal.close();
        const Toast = Swal.mixin({
          icon: 'success',
          title: emp.name + ' incorporado exitosamente',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true
        });
        Toast.fire();
        this.getDiverse();
        this.getAssinetSubAccount();
      },
      error: (err) => {
        Swal.close();
        console.error('Error al incorporar de Aasinet:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.error?.message || 'No se pudo incorporar el funcionario.',
        });
      }
    });
  }

  importSelectedAasinet() {
    const selected = this.filteredAasinetEmployees.filter(e => e.selected);
    if (selected.length === 0) return;

    this.loading('Incorporando ' + selected.length + ' funcionario(s)...');
    const payload = selected.map(emp => ({
      code: emp.code,
      names: emp.name,
      year: this.filter.year,
      version: this.filter.version,
      entityCode: this.entitySelected?.code,
      fundCode: this.fundSelect,
      type: Number(emp.selectedType || 3),
      employeeFmr: (emp.selectedType == 1 || emp.selectedType == 2) && emp.selectedFmr ? Number(emp.selectedFmr) : null,
      departamentCode: '-1',
      departamentFundCode: '0001',
      isActive: 1
    }));

    this._budgeGenrateService.saveDepartamentEmployee(payload).subscribe({
      next: () => {
        Swal.close();
        const Toast = Swal.mixin({
          icon: 'success',
          title: selected.length + ' funcionario(s) incorporado(s) exitosamente',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        });
        Toast.fire();
        this.getDiverse();
        this.getAssinetSubAccount();
      },
      error: (err) => {
        Swal.close();
        console.error('Error al incorporar lote de Aasinet:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.error?.message || 'No se pudieron incorporar los funcionarios seleccionados.',
        });
      }
    });
  }

/**busca los diverso  */
  findEmployee(code): boolean {
    let isActive=false;
    isActive=this.dataDiverse?.some((diverse) => diverse.code === code)
    return isActive
   
	}


  /*mapea los datos del ng-select */
  ngSelectData(diverse) {
    let newData = diverse.map((d) => {
      return {
        diverse: d.code,
        nameDiverse: d.code + ' - ' + d.names,
        name: d.names,
        type:d.employeeTypeName
      }
    });
    return newData
  }

    /*mapea los datos del ng-select deshabilita los registros q ya entan registrado el diverso de empleado */
    mapSelectAassinet(diverse) {
      diverse=diverse.filter(d=> !this.findEmployee(d.code))
      let newData = diverse.map((d) => {
        const name=d.name
         return {
          diverse: d.code,
          nameDiverse: d.code + ' - ' + name,
          name: name,
          isActive:true,
          disabled:false,
          
        }
      });
      return newData
    }

   /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
   onCloseNgSelectFind() {
    if(this.txtFind.length>0){
      this.dataDiverse=this.dataDiverseTemp.filter(d=>
        this.txtFind.includes(d.code)
      );
    }else{
      this.dataDiverse=this.dataDiverseTemp;
    }
  }

  addEmployee(event){
    const diverse=this.dataNgSelectAssinet.find(d=>d.diverse==event.diverse)
    diverse.isActive=false;
    diverse.disabled=true;
    this.dataNgSelectAssinet = [...this.dataNgSelectAssinet];
    this.formDiverse.patchValue({
      code:event.diverse,
      names:event.name,
      year:this.filter.year,
      version:this.filter.version,
      entityCode:this.entitySelected.code,
      fundCode:this.fundSelect,
      type:this.selectedEmployeeType
    })
    this._budgeGenrateService.saveDepartamentEmployee(this.formDiverse.value).subscribe(res => {
     
    })

    
  }

  blurNgSelect(){
   this.selectedEmployee=[]
   this.getDiverse();
    
  }


    /*filtra los datos por fund*/

    changeFund(fundCode) {
      if(this.dataDiverseTemp){
      this.fundSelect=fundCode;
      this.dataDiverse = this.dataDiverseTemp.filter(d => 
        d.fundCode==this.fundSelect
      );
      this.dataListDiverse = this.ngSelectData(this.dataDiverse);
      this.activeEmployees = (this.dataDiverse || []).filter(e => e.isActive);
      this.inactiveEmployees = (this.dataDiverse || []).filter(e => !e.isActive);
      this.filterActiveEmployees();
      this.filterInactiveEmployees();
      if (this.budgetStatus == 2) {
        this.loadPendingAps();
      }      
    }
  }


  
  /*abre los modales */
  open(content) {
    this.modalRef = this.modalService.open(content);
  }

   /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }


  /**abre el modal del diverse */

  openModalDiverse() {
    this.isNewDiverse=true
    this.modalHeaderDiverse = 'Nuevo Diverso';
    this.formDiverse.markAsPristine();
    this.formDiverse.reset();
    this.open(this.modalDiverse);
    setTimeout(() => {
      this.ngSelectAssinet.focus();
    }, 0);
  }


  /**carga los datos al pinchar en la tabla editar */

  setFormDiverse(params) {
   this.validateDiverse(params.code)
    this.modalHeaderDiverse = 'Modificar Diverso';
    this.id=params.id;
    this.formDiverse.patchValue({
      code:params.code,
      names:params.names,
      year:this.filter.year,
      version:this.filter.version,
      entityCode:this.entitySelected.code,
      fundCode:this.fundSelect,
      type:params.type,
      employeeFmr: (params.type === 1 || params.type === 2) ? params.employeeFmr : null
    })
    this.formDiverse.get('type').disable();
    this.formDiverse.markAsPristine();
    this.open(this.modalDiverse);
    if(this.diverseFinded==true){
      setTimeout(() => {
        this.ngSelectAssinet.focus();
      }, 0);
    }
  }

  validateDiverse(diverse){
    const foundItem = this.dataNgSelectAssinet.find(item => item.diverse === diverse);
    if (foundItem) {
      this.diverseFinded=true
    }
    this.diverseCopy=diverse
  }

  /**al momento de cerrer el ng select pasa el foco al input name y le asigna el valor de name  */
  onCloseNgSelectAssinet() {   
    const selected = this.dataNgSelectAssinet.find(i => i.diverse === this.formDiverse.get('code').value)
    if(selected?.name){
      this.formDiverse.get('names').patchValue(selected.name);
      this.nameInput.nativeElement.focus();
      this.nameInput.nativeElement.select();
    }
  }


  /**carga los datos al pinchar en la tabla editar */

  editDiverse(){
    this.diverseFinded=true
  }

  /**cambia la fecha en formato compatible para el mostrar campo de fecha */
  setDate(date?) {
    const expirationDate = date ? new Date(date) : new Date();
    let formatDate = {
      year: date ? expirationDate.getFullYear() : expirationDate.getFullYear() + 1,
      month: expirationDate.getMonth() + 1,
      day: date ? expirationDate.getDate() : expirationDate.getDate() + 1
    };
    return formatDate
  }

  /**cambia la fecha en formato compatible para guardar la fecha en la base de datos */
  setDateSave(date) {
    let year = date.year;
    let month = date.month < 10 ? `0${date.month}` : date.month;
    let day = date.day < 10 ? `0${date.day}` : date.day;
    let newDate = `${year}-${month}-${day}`
    return newDate;
  }

  /**Elimnar diverso */
  deleteDiverse(params) {
    const loadingToast = Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Estás seguro de eliminar: ' + params.code + ' ' + params.names+'? Se eliminaran todos los registros del usuario incluyendo detalle de salario y de primas infantiles ',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this._budgeGenrateService.deleteDepartamentEmployee(params).subscribe(res => {          
          this.dataListDiverse=undefined;
          this.getDiverse();
          this.getAssinetSubAccount();
        }, (error => console.error(error)))
      }
    });
  }


  /*envia la informacion para un nuevo diverso*/
  submitDiverseNew() {
    if (this.formDiverse.valid) {
      let data = this.newData(this.formDiverse.value);
      this._budgeGenrateService.saveDepartamentEmployee(data).subscribe(res => {
        this.close();
        this.dataListDiverse=undefined;        
        this.getDiverse();   
        this.getAssinetSubAccount();     
      }, (error => console.error(error)))
    }
  }

  /*envia la informacion para un actualizar diverso*/
  submitDiverseUpdate() {
    
    if (this.formDiverse.valid) {
      let data = this.newData(this.formDiverse.value);
      data['id']=this.id;
      this._budgeGenrateService.updateDepartamentEmployee(data).subscribe(res => {   
        let employee=this.setEmployee(this.id)     
        this.close();
        this.getDiverse();
        this.getAssinetSubAccount();
      }, (error => console.error(error)))

    }
  }

  
  setEmployee(id) {
    return this.dataDiverse.find(em => em.id == id);
  }


  findEmployeetype(id) {
    const type=this.dataEmployeeType?.find(em => em.id == id);
    return type?type.name:id;
  }

  
  /*Activa o desactiva un diverso*/
  UpdateDiverseActive(params,isActive) {
    let employee=this.setEmployee(params.id)
    employee.isActive=isActive
    this.sortDiverseByIsActive();
    this._budgeGenrateService.updateDepartamentEmployee({id:params.id,isActive:isActive}).subscribe(res => {
      const Toast = Swal.mixin({
        icon: 'success',
        title: 'Datos Actualizados',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500, // El toast dura 2 segundos
        timerProgressBar: true,
      });
      Toast.fire();     
    }, (error => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron actualizar los datos.',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
    }))
  }

  sortDiverseByIsActive() {
        this.dataDiverse.sort((a, b) => {
       return (a.isActive === b.isActive) ? 0 : a.isActive ? -1 : 1;
    });
  }

  maxDateValidator(control: any) {
    const selectedDate = new Date(control.value);
    const today = new Date();

    // Ajuste para comparar solo fechas (sin horas)
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      return { dateInvalid: true }; // Error si la fecha es posterior a hoy
    }
    return null; // Válido si es igual o anterior a hoy
  }


}



